// Romanian counts: "1 echipament", "5 echipamente", "20 de echipamente"
export function amount(n, one, many) {
  const count = Number(n) || 0;
  if (count === 1) return `1 ${one}`;
  const de = count >= 20 && (count % 100 === 0 || count % 100 >= 20);
  return `${count} ${de ? "de " : ""}${many}`;
}
